(() => {
  if (window.__storeforgeDirectThemeCommerce) return;
  window.__storeforgeDirectThemeCommerce = true;
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-storeforge-add-to-cart]') : null;
    if (!(target instanceof HTMLButtonElement)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    const handle = target.dataset.storeforgeProductHandle;
    if (!handle || target.disabled) return;
    const original = target.textContent || 'Add to cart';
    target.disabled = true;
    target.setAttribute('aria-busy', 'true');
    target.textContent = 'Adding…';
    try {
      const productResponse = await fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!productResponse.ok) throw new Error('product');
      const product = await productResponse.json();
      const variant = Array.isArray(product.variants)
        ? product.variants.find((item) => item && item.available !== false) || product.variants[0]
        : null;
      if (!variant || !variant.id) throw new Error('variant');
      const cartResponse = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
      });
      if (!cartResponse.ok) throw new Error('cart');
      window.location.assign(root() + 'cart');
    } catch (_error) {
      window.location.assign(root() + 'products/' + encodeURIComponent(handle));
      target.disabled = false;
      target.removeAttribute('aria-busy');
      target.textContent = original;
    }
  }, true);
})();
